import { Component, OnInit } from '@angular/core';
import {
  CampaignOffers,
  CampaignOffersQuery,
  CampaignOffersService,
  RewardsWalletItem,
  RewardsWalletQuery,
  RewardsWalletService,
} from '@fgb/core';
import { Observable, firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-wallet-claimed-page',
  templateUrl: './wallet-claimed-page.component.html',
  styleUrls: ['./wallet-claimed-page.component.scss'],
})
export class WalletClaimedPageComponent implements OnInit {
  walletItemsClaimed$: Observable<RewardsWalletItem[]>;
  campaignOffers$: Observable<CampaignOffers | undefined>;

  constructor(
    private rewardsWalletQuery: RewardsWalletQuery,
    private campaignOffersQuery: CampaignOffersQuery,
    private campaignOffersService: CampaignOffersService,
    private rewardsWalletService: RewardsWalletService
  ) {}

  ngOnInit() {
    firstValueFrom(this.campaignOffersService.fetchOffers());
    this.campaignOffers$ = this.campaignOffersQuery.selectFirst();

    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
    this.walletItemsClaimed$ = this.rewardsWalletQuery.selectRewardWalletItemsHistory();
  }
}
